import React, { Component } from "react";

import styled from "styled-components";
import {
  Button,
  Card,
  CardBody,
  CardTitle,
  Col,
  Container,
  Row,
  InputGroup,
  Form,
  CardHeader,
} from "reactstrap";
import Breadcrumbs from "../../../../../components/Common/Breadcrumb";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import FormToFilterReport from "../../../../../components/forms/FormToFilterReport";
import CustomBarChart from "../../../../../components/Charts/barChart";
import DountChart from "../../../../../components/Charts/dountChart";
import Flatpickr from "react-flatpickr";
import CustomSplineArea from "../../../../../components/Charts/splineArea";
import { getCurrentDay, getSelectedMonthAgo } from "../../../../../helpers/utils";
import { getOffers } from "../../../../../store/offers/actions";

class AppReports extends Component {
  constructor(props) {
    super(props);

    this.state = {};
  }

  componentDidMount() {}

  componentDidUpdate(prevProps, prevState, snapshot) {}

  render() {
    return (
      <React.Fragment>
        <Row>
          <Col sm={6}>
            <StyledCard>
              <CardBody>
                <Row className="justify-content-between align-middle">
                  <Col xs={6}>
                    <h5 className="fw-bold">Common profit by app</h5>
                  </Col>
                </Row>
                <DountChart
                  data={this.props.appProfit}
                  categories={["tracker_app_id"]}
                  yaxisName="PROFIT BY APP"
                  typeChart="donut"
                  currency="$"
                />
              </CardBody>
            </StyledCard>
          </Col>
          <Col sm={6}>
            <StyledCard>
              <CardBody>
                <Row className="justify-content-between align-middle">
                  <Col xs={6}>
                    <h5 className="fw-bold">Campaigns count by app</h5>
                  </Col>
                </Row>
                <DountChart
                  data={this.props.countByApp}
                  categories={["tracker_app_id"]}
                  yaxisName="COUNT BY APP"
                  typeChart="donut"
                  currency=""
                />
              </CardBody>
            </StyledCard>
          </Col>
        </Row>
      </React.Fragment>
    );
  }
}

const StyledCard = styled(Card)`
  border: 2px solid rgba(0, 0, 0, 0.05);
`;

AppReports.propTypes = {
  profitPyEachDay: PropTypes.any,
  mediaBuyerProfit: PropTypes.any,
  offerProfit: PropTypes.any,
  appProfit: PropTypes.any,
  countByApp: PropTypes.any,
};

export default connect()(AppReports);
